import React, { useEffect } from "react";

// Google AdSense ad units for the website (not used in the app, which uses AdMob, or on portals).
// Shown only while WEBSITE_ADSENSE_ENABLED (ads.ts) is on; the loader script is added by adsense.ts.
// Create a "Display ad" unit for each slot in AdSense (Ads > By ad unit) and paste its
// data-ad-slot number here. While a slot is empty, the site falls back to the house ad
// set up in /admin (Firestore "ads" collection), or shows nothing.
export const ADSENSE_CLIENT = "ca-pub-8481626500059505";
export const ADSENSE_SLOTS: { [placement: string]: string } = {
  Mobile: "5140767065", // fixed 320x50 banner at the top of the screen on phones
  Desktop: "5949743867", // 320x50 banner at the bottom of the rules sidebar on larger screens
};

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

function AdSenseUnit({ slot, width, height }: { slot: string; width: number; height: number }) {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Ads must never break the game.
    }
  }, [slot]);
  return (
    <ins
      className="adsbygoogle"
      style={{ display: "inline-block", width, height }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
    />
  );
}

export default AdSenseUnit;
